import styled from "styled-components";

export const Details = styled.div`
padding: 2rem;
background-color: red;
color: white;
width: fit-content;
border-radius: 1rem;
font-size: 1.5rem;
margin: 0 auto;
text-align: center;
`;